import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { applicationConfig } from './app/app-config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(environment.startupComponent, applicationConfig).catch((error) => {
  console.error(error);
});
